export default {
  namespaced: true,
  swift_collector: {
    title: "Swift Gateways",
    id_external: "id externa",
    first_contact_time: "hora do primeiro contato",
    last_contact_time: "último horário de contato",
    guid: "guía",
    manufacturer: "fabricante",
    model: "modelo",
    hardware_revision: "patch de hardware",
    software_revision: "patch de software",
    serial_number: "número de série",
    name: "Nome",
    description: "Descrição",
    latitude: "latitud",
    longitude: "longitud",
    elevation: "elevação",
    connection_type: "Tipo de conexão",
    connection_pref: "preferência de conexão",
    network: "rede",
    signal_strength: "sinal de força",
    is_new: "é novo",
    ethernet_mac_address: "endereço mac ethernet",
    wifi_mac_address: "endereço mac wifi",
    ip_address: "endereço ip",
    wifi: "wifi",
    ble: "ble",
    cell: "cell",
    gps: "gps",
    radio_gen2: "radio gen2",
    ble_gen3: "ble gen3",
    zigbee: "zegbee",
    zwave: "zwave",
    radio: "radio",
    id_swift_account: "id swift account",
    id_unit: "id instalação",
  },
};
